import React, {ReactElement, useMemo} from 'react';
import {Carousel} from '@customink/pigment-react';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import './index.scss';

type CarouselProps = {
  urls: string[];
  sliderHeight?: string;
  background?: 'white' | 'gray';
  mobile?: boolean;
};

const ProductCarousel: React.FC<CarouselProps> = ({
  urls,
  sliderHeight,
  background,
  mobile
}: CarouselProps): ReactElement => {
  const NUM_OF_THUMBNAILS = 6;

  const carouselImages = useMemo(() => {
    if (urls) {
      const images = [];
      images.push(
        ...urls.map((item: string, index: number) => {
          return <img src={item} alt={index.toString()} />;
        })
      );
      return images;
    }
    return [];
  }, [urls]);

  const PlaceHolder = () => {
    return (
      <Box className="productCarousel-placeholder">
        <Skeleton className="placeholder-slider" variant="rectangular" />
        {!mobile ? (
          <div className="placeholder-thumbnail-container">
            {Array.from(Array(NUM_OF_THUMBNAILS).keys()).map(item => {
              return <Skeleton className="thumbnail-skeleton" key={item} />;
            })}
          </div>
        ) : null}
      </Box>
    );
  };

  return urls ? (
    <div className="productCarousel">
      <div className="productCarousel-carousel">
        <Carousel
          slides={carouselImages}
          thumbnails={
            mobile
              ? undefined
              : (carouselImages as unknown as HTMLImageElement[])
          }
          navigatorSide="bottom"
          thumbSize="small"
          sliderBg={background}
          sliderHeight={sliderHeight}
        />
      </div>
    </div>
  ) : (
    <PlaceHolder />
  );
};

ProductCarousel.defaultProps = {
  mobile: false,
  sliderHeight: undefined,
  background: undefined
};

export default ProductCarousel;
